module.exports = "../dist/frontend/images/gold/carousel/travel/travel.svg?19324e031db3502466ebc44d59172518";